import { Check, AlertTriangle } from "lucide-react";
import { PROGRESS_STEPS, progressIndex, COFFEE_TYPES, formatDay } from "../../lib/labels";

export const CoffeeProgress = ({ status, testid = "coffee-progress" }) => {
  const idx = progressIndex(status);
  return (
    <div data-testid={testid}>
      {status === "PROBLEM" && (
        <p className="mb-3 inline-flex items-center gap-1.5 text-xs font-semibold text-red-700" data-testid={`${testid}-problem`}>
          <AlertTriangle className="h-4 w-4" /> Kebun sedang perlu penanganan
        </p>
      )}
      <ol className="grid grid-cols-4 gap-x-2 gap-y-3">
        {PROGRESS_STEPS.map(([k, label], i) => {
          const state = idx < 0 ? "upcoming" : i < idx ? "done" : i === idx ? "current" : "upcoming";
          return (
            <li key={k} className="min-w-0" data-testid={`${testid}-step-${k}`} data-state={state}>
              <div className={`h-1.5 rounded-full ${state === "done" ? "bg-emerald-600" : state === "current" ? "bg-amber-500" : "bg-slate-200"}`} />
              <p className={`mt-1.5 text-[11px] leading-tight ${state === "current" ? "font-bold text-amber-800" : state === "done" ? "text-emerald-800" : "text-slate-400"}`}>
                {state === "done" && <Check className="inline h-3 w-3 mr-0.5" />}{label}
              </p>
              {state === "current" && <p className="text-[10px] font-bold uppercase tracking-wide text-amber-700">Saat ini</p>}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const n = (v) => (v != null ? Number(v).toLocaleString("id-ID") : null);

export const coffeeRows = (p) => [
  ["Jenis Kopi", COFFEE_TYPES[p.coffeeType] || p.commodity], ["Varietas", p.coffeeVariety],
  ["Target Populasi", p.targetTrees != null && `±${n(p.targetTrees)} pohon`], ["Populasi Saat Ini", n(p.currentTrees)],
  ["Pohon Hidup", n(p.livingTrees)], ["Pohon Mati", n(p.deadTrees)], ["Pohon Sulaman", n(p.replacementTrees)],
  ["Tanggal Tanam", p.plantingDate && formatDay(p.plantingDate)], ["Jarak Tanam", p.plantingSpacing],
  ["Pohon Naungan", p.shadeTrees], ["Pembungaan", p.floweringStatus], ["Perkembangan Buah", p.fruitStatus],
  ["Status Panen", p.harvestStatus],
];

export const CoffeeData = ({ p, testid = "coffee-data" }) => (
  <dl className="bg-white border rounded-xl p-5 grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm" data-testid={testid}>
    {coffeeRows(p).map(([k, v]) => (
      <div key={k}><dt className="text-xs text-slate-500">{k}</dt><dd className="font-medium text-slate-900">{v || "-"}</dd></div>
    ))}
  </dl>
);
